import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import TextInput from '../../../../Shared/TextInput/TextInput';
import PopUp from '../../../../Shared/Popup/PopUp';
import {connect} from 'react-redux';
import {OptionPopUp} from '../optionPopUp/OptionPopUp';
import {setOptionsData,setOptionInputError} from '../../familyMemberCellularSaleSlice';
import {IsExternalCompanyNumber} from '../../../IdfSaleBlock/IdfSaleSlice';


const OptionInput = React.forwardRef((props, ref,) => {

  const [textInput, setTextInput] = useState(props.store.optionsData?.['option' + props.optionInputKey]?.input ?? '');
  const [showPopUp, setShow] = useState(false);

  const classifyValidInput = async(currentInput) => {

    const numberInfo=await props.IsExternalCompanyNumber({"phoneNumber":currentInput});

    if(numberInfo?.payload){
      numberInfo.payload?.isSuccess
      ?(() => {
          const isCellcomNum = numberInfo.payload?.phoneOperatorName === "CELL";
            props.setOptionsData({
              ...props.store.optionsData,
              ["option" + props.optionInputKey]: {
                "inputType":props.currentOption?.optionType,
                "input": currentInput,
                "isCellcomNum": isCellcomNum, 
              },
            })
          
        })()
      :numberInfo.payload?.codeError === "INT99"
      ? props.setOptionInputError('המספר שהקלדת לא תקין') 
      :console.error("general problem with IsExternalCompanyNumber api");   
    }
    else{
      props.setOptionInputError('אנא הזן את המספר פעם נוספת');
      console.error("Error in input validation");
    }
  };

  const inputValidation = (currentInput) => {
    let tempErrorMsg = '';
    if(currentInput.length === 0){
      tempErrorMsg = "אנא הזן מספר טלפון לניוד";
    }
    else if (currentInput.length === 10) {
      if (currentInput[0] === '0' && currentInput[1] === '5') {
        classifyValidInput(currentInput);
      } else {
        tempErrorMsg = "מספר הנייד חייב להתחיל בספרות '05'";
      }
    } else {
      tempErrorMsg = 'המספר שהקלדת לא תקין';
    }
    props.setOptionInputError(tempErrorMsg);
  };

  const textInputChange = (e) => {
    const currentInput = e.target.value;
    inputValidation(currentInput);
    setTextInput(currentInput);
  };

  return (
    props.store.selected === props.optionInputKey &&
    Object.keys(props.currentOption?.checkedInputObj ?? {}).length !== 0 && (
      <div className='idf-family-members-sale-checked-option-input'>
        <span className='heading'>{props.currentOption?.checkedInputObj?.heading}</span>
        <div className='secondary-heading-wrapper'>
          {props.currentOption?.checkedInputObj?.secondaryGrayHeadingIconUrl && (
            <Image className='secondary-heading-icon' src={props.currentOption?.checkedInputObj?.secondaryGrayHeadingIconUrl} />
          )}
          <div className='secondary-heading'>
            <div className='secondary-heading-text'>{props.currentOption?.checkedInputObj?.secondaryGrayHeading}</div>
            <div className='secondary-heading-link-text' onClick={() => setShow(true)}>
              {props.currentOption?.checkedInputObj?.linkText}
            </div>
            <PopUp showPopUp={showPopUp} onClose={() => setShow(false)}>
              <OptionPopUp 
                  popUpObj={props.currentOption?.checkedInputObj?.popUp} 
                  onBtnClick={() =>setShow(false)} 
              />
            </PopUp>
          </div>
        </div>
        {Object.keys(props.currentOption?.checkedInputObj?.textInput ?? {}).length !== 0 && (
          <TextInput
            ref={ref}
            onChange={(e) => {
              textInputChange(e);
            }}
            value={textInput}
            name='id'
            type={props.currentOption?.checkedInputObj?.textInput?.type ?? 'no-type'}
            placeholder={props.currentOption?.checkedInputObj?.textInput?.placeholder ?? ''}
            required={props.currentOption?.checkedInputObj?.textInput?.required ?? false}
            error={props.store.optionInputError}
          />
        )}
      </div>
    )
  );
});
OptionInput.displayName = 'OptionInput';

const mapStateToProps = (state) => {
  return {
    store: state.familyMemberCellularSale,
  };
}

const mapDispatchToProps = {
  setOptionsData,
  IsExternalCompanyNumber,
  setOptionInputError,
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionInput);
